import { __extends } from "tslib";
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons/faTrashAlt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import map from 'lodash/map';
import reduce from 'lodash/reduce';
import * as React from 'react';
import { Button } from '../../Button';
import { Input } from '../../Input';
var handleChange = function (func) {
    return function (_a) {
        var value = _a.target.value;
        return func(value);
    };
};
var PatternPropertiesField = (function (_super) {
    __extends(PatternPropertiesField, _super);
    function PatternPropertiesField(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyChange = function (key) {
            return function (_a) {
                var value = _a.target.value;
                var keys = _this.state.keys;
                var index = keys.indexOf(key);
                if (index > -1) {
                    keys[index] = value;
                }
                else {
                    keys.push(value);
                }
                _this.props.onKeyChange(key)(value);
                _this.setState({ keys: keys });
            };
        };
        var keys = Object.keys(props.formData || {});
        _this.state = {
            keys: keys,
        };
        return _this;
    }
    PatternPropertiesField.prototype.render = function () {
        var _this = this;
        var _a = this.props, formData = _a.formData, schema = _a.schema;
        if (!schema.patternProperties) {
            return null;
        }
        var pattern = Object.keys(schema.patternProperties)[0];
        var tableData = reduce(formData, function (carry, value, key) {
            if (!schema.properties || !schema.properties[key]) {
                carry.push({
                    value: value,
                    key: key,
                });
            }
            return carry;
        }, []);
        tableData.sort(function (a, b) {
            var indexA = _this.state.keys.indexOf(a.key);
            if (indexA === -1) {
                return 1;
            }
            return _this.state.keys.indexOf(a.key) - _this.state.keys.indexOf(b.key);
        });
        tableData.push({ value: '', key: '' });
        var subSchema = schema.patternProperties[pattern];
        return (React.createElement("table", null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Key"),
                    React.createElement("th", null, subSchema.title || 'Value'))),
            React.createElement("tbody", null, map(tableData, function (item, index) {
                var isLast = index + 1 === tableData.length;
                return (React.createElement("tr", { key: index },
                    React.createElement("td", null,
                        React.createElement(Input, { value: item.key, className: "rendition-form-pattern-properties__key-field", disabled: isLast, pattern: pattern, placeholder: 'Key', onChange: _this.handleKeyChange(item.key) })),
                    React.createElement("td", null,
                        React.createElement(Input, { value: item.value, id: "foo", className: "rendition-form-pattern-properties__value-field", placeholder: subSchema.title || 'Value', onChange: handleChange(_this.props.onPropertyChange(item.key)) }),
                        !isLast && (React.createElement(Button, { className: "rendition-form-pattern-properties__remove-field", plain: true, primary: true, py: 1, px: 2, onClick: _this.props.onDropPropertyClick(item.key) },
                            React.createElement(FontAwesomeIcon, { icon: faTrashAlt }))))));
            }))));
    };
    return PatternPropertiesField;
}(React.Component));
export default PatternPropertiesField;
